import { useAuth } from "@/context/AuthContext";
import ClientDashboard from "@/dashboards/ClientDashboard";
import ProfessionalDashboard from "@/dashboards/ProfessionalDashboard";
import CaregiverDashboard from "@/dashboards/CaregiverDashboard";
import AdminDashboard from "@/dashboards/AdminDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  const Map = {
    client: ClientDashboard,
    professional: ProfessionalDashboard,
    caregiver: CaregiverDashboard,
    admin: AdminDashboard,
  };
  const Comp = Map[user.role] || ClientDashboard;
  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tighter text-slate-900 mb-6">
        {user.role === "admin" ? "Administrator" : user.role.charAt(0).toUpperCase() + user.role.slice(1)}{" "}
        <span className="text-[#9b111e]">Dashboard</span>
      </h1>
      <Comp />
    </div>
  );
}
